module.exports = __webpack_public_path__ + "static/snapcode-87b622ed2e996f4a03ae3196fd8e4d41.png";